import React, { useMemo } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { getMenuItems } from "../Menu/Menu";
import { useAuth } from "../../Pages/auth";
import "./NavigationBar.css";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  const visibleMenus = useMemo(
    () => getMenuItems(user?.role_code),
    [user?.role_code]
  );
  console.log(visibleMenus);
  

  const activeMenu = visibleMenus.findIndex(
    (item) => location.pathname.startsWith(item.path)
  );
  console.log(activeMenu);
  
  const activeSubmenu = activeMenu !== -1 ? visibleMenus[activeMenu].submenu : null;
  const activeSubIndex = activeSubmenu
    ? activeSubmenu.findIndex((sub) => location.pathname === sub.path)
    : -1;

  const handleMenuClick = (index) => {
    const item = visibleMenus[index];
    if (item.label === "Logout") {
      logout();
      navigate("/login");
      return;
    }
    navigate(item.path);
  };

  return (
    <div className="navbar-container">
      <nav className="navbar">
        <ul className="menu">
          {visibleMenus.map((menu, index) => (
            <li key={index} className="menu-item">
              <button
                className={`menu-button ${activeMenu === index ? "active" : ""}`}
                onClick={() => handleMenuClick(index)}
                style={{ color: activeMenu === index ? "#810055" : "black" }}
              >
                {menu.label}
              </button>
            </li>
          ))}
        </ul>
      </nav>

      {activeSubmenu && (
        <div className="submenu-container">
          <ul className="submenu">
            {activeSubmenu.map((sub, subIndex) => (
              <li key={subIndex}>
                <Link
                  to={sub.path}
                  className="submenu-link"
                  style={{ color: activeSubIndex === subIndex ? "#810055" : "black" }}
                >
                  {sub.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Navbar;
